import { Button, ButtonVariant } from '@Core/Components'
import { PermissionWrapper } from '@Core/Components/PermissionWrapper/PermissionWrapper'
import { NeedSourceItem, ProductionLinksResult } from '@Purchasing/Domain/Model/PurchaseProcess'
import { roles } from '@Purchasing/roles'
import { formatDateTimePt } from '@Purchasing/presentation/purchasing-labels'
import { detailCardClass } from './parts'

export const ProductionSection = ({ data, loading, error, sourceItems, onConfirm, onUnlink, onRefresh }: {
    data: ProductionLinksResult | null
    loading: boolean
    error?: string | null
    sourceItems: NeedSourceItem[]
    onConfirm: (id: string) => void
    onUnlink: (id: string) => void
    onRefresh: () => void
}) => (
    <section className={`${detailCardClass} mt-4`} data-testid="production-section">
        <div className="mb-3 flex items-center justify-between gap-2">
            <h2 className="text-lg font-semibold">Produção</h2>
            <div className="flex items-center gap-2">
                {data?.summary.needsReview ? <span className="text-sm font-medium text-warning-600">{data.summary.needsReview} para revisar</span> : null}
                <PermissionWrapper permission={roles.production.permissions.refresh.key}>
                    <Button variant={ButtonVariant.secondary} onClick={onRefresh} disabled={loading}>Atualizar produção</Button>
                </PermissionWrapper>
            </div>
        </div>
        {loading ? <p className="text-sm text-gray-500">Carregando produção…</p> : !data?.items.length ? (
            <p className="text-sm text-gray-500 dark:text-gray-400">Nenhum ticket de produção vinculado ainda.</p>
        ) : <ul className="space-y-2">
            {data.items.map((link) => (
                <li key={link._id} className="rounded border border-gray-200 p-3 dark:border-gray-700">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                        <div>
                            <p className="font-medium">{link.ticketSnapshot?.title || `Ticket ${link.ticketExternalId}`}</p>
                            <p className="text-xs text-gray-500">Ticket #{link.ticketExternalId} · atualizado {formatDateTimePt(link.lastSyncedAt)}</p>
                        </div>
                    {link.matchStatus === 'NEEDS_REVIEW' ? <span className="text-sm text-warning-600">Precisa de revisão</span> : <span className="text-sm text-od-primary-800">{link.matchSource === 'MANUAL' ? 'Vínculo confirmado manualmente' : 'Vinculado automaticamente'}</span>}
                    </div>
                    {link.ticketSnapshot?.statusLabel ? <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">{link.ticketSnapshot.statusLabel}</p> : null}
                    {link.sourceItemExternalIds.length > 0 && <ul className="mt-1 text-xs text-gray-500">{link.sourceItemExternalIds.map((id) => {
                        const item = sourceItems.find((source) => source.sourceItemExternalId === id)
                        return <li key={id}>• {item?.description ?? 'Item de origem'}{item?.quantity ? ` — ${item.quantity} un.` : ''}</li>
                    })}</ul>}
                    <PermissionWrapper permission={roles.production.permissions.link.key}>
                        <div className="mt-2 flex gap-2">
                            {link.matchStatus === 'NEEDS_REVIEW' && <Button variant={ButtonVariant.primary} onClick={() => onConfirm(link._id)}>Confirmar vínculo</Button>}
                            {link.matchSource === 'MANUAL' && <Button variant={ButtonVariant.secondary} onClick={() => onUnlink(link._id)}>Desvincular</Button>}
                        </div>
                    </PermissionWrapper>
                </li>
            ))}
        </ul>}
        {error ? <p className="mt-3 text-sm text-warning-600">{error} {data ? 'Os últimos dados sincronizados continuam disponíveis.' : ''}</p> : null}
        {data?.summary.lastSyncedAt ? <p className="mt-3 text-xs text-gray-500">Atualizado em {formatDateTimePt(data.summary.lastSyncedAt)}</p> : null}
    </section>
)
